import { useMutation } from "@apollo/client/react/hooks";
import {UpdateCultivationDenseVariables, UpsertCultivationDense} from "../__generated__/types";
import { CultivationDenseUpsert } from "../pages/21/planning21.gql";
import {createCultivationEvents} from "../shared/utils/domain/cultivation.utils";
import useUpdateCultivationMutation from "./useUpateCultivationMutation";

const useUpsertCultivationMutation = () => {
  const [upsertCultivationMutation] = useUpdateCultivationMutation();
  return useMutation<UpsertCultivationDense>(CultivationDenseUpsert, {
    onCompleted(data, options) {
      const cultivationEvents = createCultivationEvents(data.upsertCultivation);

      const variables: UpdateCultivationDenseVariables = {
        cultivationId: data.upsertCultivation.id,
        data: {
          events: {
            delete: data.upsertCultivation.events?.map(({id}) => ({id})),
            create: cultivationEvents
          }
        },
      };

      upsertCultivationMutation({
        variables,
        refetchQueries: "active",
      }).then(() => console.log('events created'));
    },
    update(cache, {data}) {
      cache.modify({
        fields: {
          cultivations: (previous) => {
            if (data) {
              return [...previous, data.upsertCultivation];
            } else {
              return previous;
            }
          }
        }
      })
    }
  });
};

export default useUpsertCultivationMutation;
